import { Logo } from '@highlight/ui'

import { HeroGradient, heroLabelClass } from './hero-gradient'

/** Step 2: an example meeting card with its drafted brief. */
export function HeroUpcoming() {
  return (
    <HeroGradient>
      <div className="corner-smooth border-black-4 flex w-full flex-col gap-3 rounded-xl border bg-white p-3 shadow-[0_2px_8px_1px_rgba(0,0,0,0.06)]">
        <div className="flex items-center gap-2">
          <span className="corner-smooth border-black-5 flex size-5 shrink-0 items-center justify-center rounded-md border bg-white shadow-[0_0_2px_1px_rgba(0,0,0,0.05)]">
            <Logo name="google-meet" size="sm" />
          </span>
          <p className={`${heroLabelClass} type-ui-sm truncate`}>Weekly Kickoff</p>
        </div>
        <div className="corner-smooth border-black-4 rounded-lg border bg-white px-3 py-2 shadow-[0_0_12px_2px_rgba(0,0,0,0.06)]">
          <p className="type-ui-xs text-on-light">Last week’s action items:</p>
          <ul className="list-disc ps-[18px]">
            <li className="type-ui-xs text-on-light truncate">
              Follow-up with report on the latest applicants in the pipeline
            </li>
          </ul>
        </div>
      </div>
    </HeroGradient>
  )
}
